import { render, staticRenderFns } from "./DateComponent.vue?vue&type=template&id=659cd964&scoped=true&"
import script from "./DateComponent.vue?vue&type=script&lang=js&"
export * from "./DateComponent.vue?vue&type=script&lang=js&"
import style0 from "./DateComponent.vue?vue&type=style&index=0&id=659cd964&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659cd964",
  null
  
)

export default component.exports